module.exports = __webpack_public_path__ + "img/linkedin4.c8a69361.svg";